module.exports = __webpack_public_path__ + "media/images/icon__breadcrumbs-arrow-left--rb-raven-gray-2d23ccefde783436584c41896d1d58fd.png";